import { render } from "./PageListRiwayat.vue?vue&type=template&id=2f9e40eb"
import script from "./PageListRiwayat.vue?vue&type=script&lang=js"
export * from "./PageListRiwayat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__